import { CrudService } from './crud.service';

export class SeasonsService {
  private readonly crudService: CrudService<string[]>;

  constructor() {
    this.crudService = new CrudService<string[]>('api/seasons');
  }

  public async getSeasons(active?: boolean): Promise<string[]> {
    const queryParams = new URLSearchParams();

    queryParams.set('active', active ? 'true' : 'false');

    const result = await this.crudService.do('get', `?${queryParams}`);
    if (result.isValid() && result.model) {
      return result.model;
    } else {
      return [];
    }
  }
}
